import { ProductModel } from '../product.model';
import { ReferentielModel } from '../referentiel.model';
import { PurchaseOrderFileModel } from '../expenditure-commitment/purchase-order-file.model';

export class PurchaseOrderModel {
  public id: number = null;
  public number: number = null;
  public product: ProductModel = new ProductModel();
  public costCenterId: number = null;
  public costCenterName = '';
  public supplierMiloId: number = null;
  public supplierMiloName: string = null;
  public deliveryRadio = false;
  public expectedDeliveryDate = null;
  public description = '';
  public type = '';
  public currencyId = 32;
  public currencyLabel = '';
  public status: ReferentielModel = new ReferentielModel();
  public totalAmmountTF: number = null;
  public deliveryDate: string = null;
  public realDeliveryDate: string = null;
  public quantity = 1;
  public deliveredQuantity: number = null;
  public toBeDeliveredQuantity: number = null;
  public finalDelivery: boolean;
  public creator: string = null;
  public basketNumber: number = null;
  public orderSAPNumber: number = null;
  public creationDate: string = null;
  public currencyCode: string = null;
  public deliveryLocation: string;
  public unitPrice: number;
  public checked = false;
  public isDuplicate = false;
  public files: PurchaseOrderFileModel[] = [];
  public uuid: string;

  constructor() {
    this.status.id = 6;
  }

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: PurchaseOrderModel[] = [];
    if (jsons) {
      jsons.forEach(json => {
        refs.push(new PurchaseOrderModel().fromJSON(json));
      });
    }
    return refs;
  }
}
